/**
 * @file 带图的卡片组
 * @author FengGuang(fengguang01@baidu.com)
 *
 */

import React, {useMemo} from 'react';
import classNames from 'classnames';
import {Row} from 'antd';

import PictureTextCard from './PictureTextCard';
import {IPictureTextCardItem} from '../../types';

interface IProps {
    className?: string;
    list?: IPictureTextCardItem[];
}

const PictureTextCardGroup: React.FC<IProps> = props => {
    const className = props.className;
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);

    const xs = useMemo(() => {
        if (list.length === 2) {
            return 12;
        }
        if (list.length === 3) {
            return 8;
        }
        if (list.length === 1) {
            return 24;
        }
        return 6;
    }, [list]);

    return (
        <div
            className={classNames(
                'paddle-application-card-group-wrap',
                className
            )}
        >
            <div className="paddle-application-card-group">
                <Row justify="space-between">
                    {list.map((item, index, arr) => (
                        <PictureTextCard
                            key={`${item.title},${item.text}`}
                            title={item.title}
                            text={item.text}
                            imageUrl={item.imageUrl}
                            link={item.link}
                            target={item.target}
                            tagText={item.tagText}
                            xs={xs}
                            zIndex={arr.length - index}
                        />
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default PictureTextCardGroup;
